import React, { useState } from 'react'
import { VariableRequests } from '../VariableRequests';
import TopInputs from './TopInputs';
import SearchFilter from './SearchFilter';
import SliderCart from './SliderCart';
import Carts from './Carts';
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';
import { postRequest } from '../../../../store/Actions/ActionRequests';
import ProductFiles from '../../products/add-product/ProductFiles';

function AddRequest() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang();
    const { state, setStateCustom, setLoad } = VariableRequests();
    const [cartArr, setCartArr] = useState([])
    const [fields1, setFields1] = useState([{ file_path: '', notes: '' }])
    
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postRequest(cartArr,fields1,state, setLoad));
    };
    return (
        <>
            <main>
                <div className='div_table margin_main shadow_main' >
                    <div className='AddScriptsArchive' dir={langLocal === 'ar'? "rtl": "ltr"} >
                        <div className='d-flex' style={{ justifyContent: "space-between" }} >
                            <h3>{translate('add_request')}</h3>
                            <button className='btn-savee' onClick={handleSubmit} > {translate('save')}</button>
                        </div>
                        <br></br>
                        <TopInputs state={state} setStateCustom={setStateCustom} />
                        <SearchFilter translate={translate} langLocal={langLocal} />
                        <SliderCart cartArr={cartArr} setCartArr={setCartArr} />
                        <br></br>
                        <Carts cartArr={cartArr} setCartArr={setCartArr} />
                        <ProductFiles title={translate('files')} fields={fields1} setFields={setFields1} />
                    </div>
                </div>
            </main>
        </>
    )
}

export default AddRequest